import { Module } from '../Module';
import { GetSiteNamesAcrossAllPodsRequest, IGetSiteNamesAcrossAllPodsResult } from '../ServerApi/requests/GetSiteNamesAcrossAllPodsRequest';
import { ISiteNameSansId } from '../ServerApi/types/ISiteNameSansId';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class SiteNameSansIds extends Resource<ISiteNameSansId> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetSiteNamesAcrossAllPodsRequest,
      (result: IGetSiteNamesAcrossAllPodsResult) => result.siteNames));
  }

}

Module.instance().service('SiteNamesAcrossAllPods', SiteNameSansIds);
